{
  "titles": {
    "tasks": "Taken"
  },
  "messages": {
    "emptyStateTitle": "Geen taken",
    "emptyStateDescription": "Op dit moment zijn er geen taken. Zodra er een taak beschikbaar is, wordt deze hier automatisch weergegeven."
  },
  "taskTitles": {
    "FundingContractSend": "Contract verzenden",
    "FundingContractEnding": "Contract verlengen",
    "PaymentBatchApproval": "Uitbetalingen accorderen",
    "FundingContractValidationsCheck": "Contract voorwaardes controleren",
    "FundingContractBookReimbursement": "Deposito inleg terugbetalen",
    "FundingContractDeviationProposalRejected": "Afwijking afgekeurd",
    "FundingContractDeviationProposalRejected-interestRate": "Afwijkende rente afgekeurd",
    "FundingContractDeviationProposalRejected-durationInMonths": "Afwijkende looptijd afgekeurd",
    "LoanProcessEarlyTransfer": "Terugbetaling controleren",
    "LoanProcessRenewalRequest": "Verlengverzoek accorderen",
    "LoanProcessRenewalTransfer": "Betaling voor verlenging controleren",
    "FinanceReceiverActivateFacility": "Faciliteit activeren",
    "FinanceReceiverValidateOnboarding": "Klant onboarding valideren",
    "FinanceReceiverPaymentReferenceSurplusRefund": "Overschot aflossing terugbetalen",
    "FinanceReceiverValidateCreditRequest": "Wijziging faciliteit valideren",
    "FinanceReceiverActivateCreditLimit": "Wijziging faciliteit activeren",
    "FinanceReceiverCompleteSepaUpdateRequestTask": "Digitale SEPA controleren",
    "FinanceReceiverValidateSepaUpdateRequestTask": "Handmatige SEPA controleren"
  },
  "taskSubtitles": {
    "PaymentBatchApproval": "Via twikey"
  }
}
